import React from "react";
import '../App.css';
import { GoBackButton } from "./Utilities";

const Portfolio = () => {
    
    return (
        <div>
            <div className="secondary-header">
                <h1 className="main-text" style={{fontSize:'43px', textAlign:'left', backgroundColor:'white', margin:'10vh 8vw', fontFamily:'Atteron'}}>My <br />Portfolio</h1>
                <div style={{margin:'15vh 15vw'}}> <GoBackButton /> </div>
            </div>
            <div className="portfolio-body">
                <div className="projects">
                    <h3 className="main-text">Housing Price Predictor</h3>
                    <img src="house.png" alt="house" style={{width:"15vw"}}/>
                    <h3 className="main-text" style={{textAlign:'left'}}>Helps people predict their property price by just entering few features.</h3>
                </div>
                <div className="projects">
                    <h3 className="main-text">Credit card eligibility pridictor</h3>
                    <img src="credit.png" alt="house" style={{width:"15vw"}}/>
                    <h3 className="main-text" style={{textAlign:'left'}}>Helps you find if you're eligible for the card or not depending on few questions.</h3>
                </div>
                <div className="projects">
                    <h3 className="main-text">About Me Website</h3>
                    <img src="main-img.png" alt="house" style={{width:"15vw"}}/>
                    <h3 className="main-text" style={{textAlign:'left'}}>It's the best Profile Website you're watching right now<span role="img">🤝</span></h3>
                </div>
            </div>
        </div>
    )
}

export default Portfolio;